/*
 * Yoni PDP enhancements: a swipeable media gallery driven by thumbnails + a
 * sticky add-to-cart bar that appears once the main buy button scrolls out of view.
 * Progressive: with no JS the gallery still swipes (CSS scroll-snap) and the
 * buy form still works. Re-initialises when the theme editor re-renders the section.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function go(track, i) {
    var calm = window.yoniCalm ? window.yoniCalm() : reduceMotion.matches;
    track.scrollTo({ left: i * track.clientWidth, behavior: calm ? 'auto' : 'smooth' });
  }

  function initGallery(scope) {
    scope.querySelectorAll('[data-media-gallery]').forEach(function (gallery) {
      if (gallery.dataset.yoniGalleryInit === '1') return;
      gallery.dataset.yoniGalleryInit = '1';
      // Two columns: the gallery sticks by its bottom edge when it is taller than the window
      // (yoni-main-product.liquid), which needs its height.
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { gallery.style.setProperty('--pdp-gallery-h', gallery.offsetHeight + 'px'); }).observe(gallery);
      }
      var track = gallery.querySelector('[data-media-track]');
      var thumbs = gallery.querySelectorAll('[data-media-thumb]');
      if (!track || thumbs.length < 2 || !('IntersectionObserver' in window)) return;
      var slides = [].slice.call(track.children);

      // The chosen tile's frame is one shape that moves to the next tile like a jelly, as in the
      // buy box (yoni-motion.js). Without it the tile's own frame shows the choice.
      var goo = window.yoniGoo && window.yoniGoo(thumbs[0].closest('ul'), {
        items: '[data-media-thumb]',
        isOn: function (t) { return t.getAttribute('aria-current') === 'true'; }
      });

      function mark(i) {
        thumbs.forEach(function (t, j) {
          if (j === i) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        if (goo) goo.go();
      }

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { go(track, i); });
      });

      // The observer is the only thing that marks the active thumbnail — for
      // clicks, swipes and editor jumps alike. Marking on click too made the ring
      // jump back to the slides the smooth scroll passes on its way.
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) mark(slides.indexOf(e.target));
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { observer.observe(s); });

    });
  }

  // Theme Editor: selecting a "Gallery photo" block shows that photo.
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target;
    if (!slide.matches || !slide.matches('[data-media-slide]')) return;
    var track = slide.parentElement;
    go(track, [].indexOf.call(track.children, slide));
  });

  function initSticky(scope) {
    var bar = scope.querySelector('[data-sticky-atc]');
    var anchor = scope.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    if (bar.dataset.yoniStickyInit === '1') return;
    bar.dataset.yoniStickyInit = '1';

    var show = function (on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    show(false);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          show(!e.isIntersecting && e.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);
  }

  function init(scope) {
    initGallery(scope);
    initSticky(scope);
  }

  ready(function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
